<template>
    <portal to="modals">
        <modal
            :name="name"
            :adaptive="true"
            :scrollable="true"
            height="auto"
            width="500"
            @before-close="beforeClose"
            @before-open="beforeOpen"
        >
            <div>
                <form
                    ref="form"
                    v-loading="loading"
                    autocomplete="off"
                    class="mb-0"
                    @submit.prevent="save"
                >
                    <div class="p-2xl">
                        <div v-if="openedFromFavoriteHeart" class="max-w-xs mx-auto text-center ">
                            <font-awesome-icon :icon="['fal', 'heart']" class="text-xl mb-md" />
                            <p class="mb-2xl text-xxs">Samla dina favoriter på ett och samma ställe! Skapa ett konto eller logga in för att kunna favoritmarkera produkter.</p>
                        </div>

                        <div
                            v-if="title"
                            class="flex items-center justify-between"
                            :class="{ 'mb-3xl' : topActions, 'mb-md' : ! topActions }"
                        >
                            <h1 class="m-0 text-md">{{ title }}</h1>
                            <div v-if="topActions" class="text-xxs">
                                <slot name="topActions" />
                            </div>
                        </div>
                        <div v-if="iconTitle" class="flex flex-col items-center justify-center text-center mb-lg">
                            <font-awesome-icon :icon="icon" class="text-xl mb-lg" />
                            <h1 class="m-0 text-md">{{ iconTitle }}</h1>
                        </div>
                        <slot />
                    </div>

                    <div v-if="errors.length" class="px-2xl">
                        <div
                            v-for="(error, i) in errors"
                            :key="i"
                            class="alert is-error font-normal"
                        >
                            <div class="w-full flex flex-col">
                                <div class="flex items-center mb-xs">
                                    <div class="alert-icon">
                                        <font-awesome-icon icon="exclamation-circle" class="mr-xs" />
                                    </div>

                                    <div>
                                        <strong>{{ error.message }}</strong>
                                        <ul
                                            v-if="error.validationErrors"
                                            class="mb-0"
                                        >
                                            <li v-for="(validationError, k) in error.validationErrors" :key="k">
                                                {{ validationError[0] }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-bottom-actions">
                        <button
                            type="button"
                            class="mt-xl link text-xxs font-bold md:mt-0"
                            @click="hide"
                        >
                            {{ cancelButtonText }}
                        </button>
                        <slot name="primary-action">
                            <button
                                type="submit"
                                class="btn btn-md is-primary"
                                :class="{ [primaryButtonClass]: primaryButtonClass, 'is-primary': !primaryButtonClass }"
                            >
                                {{ primaryButtonText }}
                            </button>
                        </slot>
                    </div>
                </form>
            </div>
        </modal>
    </portal>
</template>

<script>
    import FormModal from '../../Atlantis/Components/Modals/FormModal.vue';

    export default {
        extends: FormModal,

        props: {
            iconTitle: {
                type: String,
                default: null,
            },
            icon: {
                type: Array,
                default: null,
            },
            topActions: {
                type: Boolean,
                default: false,
            },
            cancelButtonText: {
                type: String,
                default: 'Avbryt',
            },
        },

        data() {
            return {
                openedFromFavoriteHeart: false,
            };
        },

        methods: {
            beforeOpen(event) {
                if (event.params && event.params.openedFromFavoriteHeart) {
                    this.openedFromFavoriteHeart = true;
                }

                this.handleNoScrollToggle(true);
                this.$emit('before-open', event);
            },

            beforeClose(event) {
                this.$emit('hide', event);
                this.handleNoScrollToggle(false);
            },
        },
    };
</script>
